export const onlineRugbyBundesligaTrainerinnenSymposium2026 = {
  "id": "online-bundesligatrainerinnen-symposium-2026",
  "title": "1. Online Rugby-Bundesligatrainer*innen-Symposium 2026",
  "slug": "online-bundesligatrainerinnen-symposium-2026",
  "publishedAt": "2026-01-25T12:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "5 min",
  "tags": [
    "Rugby",
    "Bundesliga",
    "Trainer*innen",
    "Fortbildung",
    "Symposium",
    "Rugby Deutschland"
  ],
  "excerpt": "Am 1. März 2026 findet das 1. Online Rugby-Bundesligatrainer*innen-Symposium statt. Die Veranstaltung richtet sich an Trainer*innen der 1. und 2. Bundesliga sowie an A-Lizenz-Trainer*innen und dient dem fachlichen Austausch und der Weiterentwicklung der Trainer*innenarbeit.",
  "img": "/images/online-bundesligatrainerinnen-symposium-2026.jpeg",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Am 1. März 2026 findet von 10:00 bis 13:00 Uhr das 1. Online Rugby-Bundesligatrainer*innen-Symposium 2026 statt. Die Veranstaltung wird im Online-Format durchgeführt."
    },
    {
      "type": "paragraph",
      "content": "Das Symposium richtet sich an Trainer*innen der Rugby-Bundesligisten der 1. und 2. Bundesliga sowie an A-Lizenz-Trainer*innen. Ziel der Veranstaltung ist es, den fachlichen Austausch zu fördern, neue Impulse für die Trainings- und Spielpraxis zu geben und die Trainer*innenarbeit im Bundesligabereich weiterzuentwickeln."
    },
    {
      "type": "paragraph",
      "content": "Im Rahmen des Symposiums sind mehrere Keynotes sowie moderierte Q&A-Sessions geplant. Als Referenten wirken unter anderem Michael Poppmeier (Co-Trainer DRV XV-Männer), Curtis Bradford (Bundestrainer 7er-Frauen) sowie weitere erfahrene Trainer*innen aus dem Leistungsrugby mit."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Veranstaltungsdetails"
    },
    {
      "type": "paragraph",
      "content": "Datum: 1. März 2026\nUhrzeit: 10:00–13:00 Uhr\nFormat: Online (Zugangsdaten nach Anmeldung)\nDauer: ca. 3 Stunden\nAnerkennung: 4 Lerneinheiten (LE)"
    },
    {
      "type": "paragraph",
      "content": "Die detaillierte Tagesordnung wird den Teilnehmenden nach erfolgter Anmeldung zur Verfügung gestellt."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Anmeldung und Teilnahmegebühr"
    },
    {
      "type": "paragraph",
      "content": "Die Anmeldung erfolgt verbindlich per E-Mail an coachingbl@rugbydeutschland.org. Anmeldeschluss ist der 23. Februar 2026."
    },
    {
      "type": "paragraph",
      "content": "Die Teilnahmegebühr beträgt 25,00 Euro und ist nach Anmeldung an Rugby Deutschland e. V. zu überweisen."
    },
    {
      "type": "paragraph",
      "content": "Bankverbindung:\nRugby Deutschland e. V.\nIBAN: DE10672700030140190000\nBIC: DEUTEDESM672\nBank: Deutsche Bank\nVerwendungszweck: Bundesligatrainer-Symposium 1.3.2026"
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Organisation"
    },
    {
      "type": "paragraph",
      "content": "Das Symposium wird von Björn Frommann organisiert. Er ist A-Lizenztrainer, Referent und seit vielen Jahren im Trainer*innenumfeld aktiv. Beruflich ist er als Lehrer und Schulprozessbegleiter tätig. Aktuell unterstützt er den Rugby-Bundesligaausschuss als Referent für Trainer*innenbildung und Wissenstransfer."
    }
  ]
};
